import "@/i18n";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Contacto from "@/pages/Contacto";
import Privacidad from "@/pages/Privacidad";
import Legal from "@/pages/Legal";
import Cookies from "@/pages/Cookies";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/contacto" element={<Contacto />} />
                    <Route path="/privacidad" element={<Privacidad />} />
                    <Route path="/legal" element={<Legal />} />
                    <Route path="/cookies" element={<Cookies />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#1A1A1A",
                        color: "#F4F1EA",
                        border: "1px solid #8B6914",
                        borderRadius: 2,
                    },
                }}
            />
        </div>
    );
}

export default App;
